/* StudioColors — comportamentul componentelor de produs (redesign, lotul 1, 20 oct. 2026).
 *
 * ⚠ Fișierul ăsta NU calculează prețuri și NU pune nimic în coș. Prețul, validarea și `cart/add.js` rămân în secțiunea
 * fiecărui produs, pe atributele ei `data-*` (neschimbate). Aici stă doar ce e comun tuturor paginilor pe sistem:
 *
 *  1. Bara de comandă (`[data-sc-bar]`, snippets/sc-purchase-bar.liquid): apare după ce blocul principal de preț a ieșit
 *     din ecran în sus, dispare când revine și înaintea subsolului, se ridică peste bara de jos a temei (`toolbar-mobile`). Secțiunea îi trimite valorile cu
 *     `SC.bara.update(elementDinSectiune, { selection, meta, total, note, cta, disabled, busy, rows })` din funcția ei de
 *     update — un singur rând în plus. Butonul din bară apasă butonul existent de coș (`click()`), deci logica e una singură.
 *  2. Sheet-ul cu detaliile comenzii (`[data-sc-sheet]`): modelele pe rânduri; jos pe telefon, la mijloc pe ecran lat.
 *  3. Galeria (`[data-sc-gallery]`, snippets/sc-gallery.liquid): fotografia întâi, planșa a doua; miniaturile derulează
 *     pista (scroll-snap), pe telefon se trage cu degetul.
 *
 * Fără MutationObserver (o pagină a înghețat din cauza unuia care scria `style` și se asculta singur).
 */
(function () {
  'use strict';
  var SC = window.SC = window.SC || {};

  function $(sel, root) { return sel ? (root || document).querySelector(sel) : null; }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function text(el, v) { if (el && v != null) el.textContent = v; }

  /* ---------- 1. Bara de comandă ---------- */

  var bare = [];

  function initBara(root) {
    if (root.__scBara) return root.__scBara;
    var scope = root.closest('[data-sc-bar-scope]') || document;
    var o = {
      root: root,
      scope: scope,
      watch: $(root.getAttribute('data-sc-bar-watch'), scope),
      start: $(root.getAttribute('data-sc-bar-start'), scope),
      cta: root.getAttribute('data-sc-bar-cta'),
      qty: root.getAttribute('data-sc-bar-qty'),
      stop: $(root.getAttribute('data-sc-bar-stop') || 'footer, .footer, [id*="__footer"]'),
      stare: { watch: true, start: false, stop: false },
      layer: $('[data-sc-sheet]', root)
    };
    root.__scBara = o;
    bare.push(o);
    // Ella pune <main> pe z-index 2 (context de stivuire): înăuntru, bara și sheet-ul ar sta sub antetul lipit și sub butoanele
    // flotante ale temei. Se mută la capătul lui <body>; selectorii (watch, cta, qty) se caută în continuare în secțiune (o.scope).
    if (o.scope !== document) o.scope.__scBar = root;
    if (root.parentElement !== document.body) document.body.appendChild(root);

    function aplica() {
      var vizibil = o.stare.start && !o.stare.watch && !o.stare.stop;
      root.classList.toggle('is-visible', vizibil);
      // Ultimul control nu ajunge sub bară când pagina derulează la el (focus, ancoră): scroll-padding = bara + bara temei + 16 px.
      var bp = $('.sc-purchase', root), jos = parseFloat(root.style.getPropertyValue('--sc-bar-bottom')) || 0;
      document.documentElement.style.scrollPaddingBottom = vizibil && bp ? Math.round(bp.offsetHeight + jos + 16) + 'px' : '';
      var bar = $('.sc-purchase', root);
      if (bar) {
        bar.setAttribute('aria-hidden', vizibil ? 'false' : 'true');
        if ('inert' in bar) bar.inert = !vizibil;
      }
    }
    o.aplica = aplica;

    // Starea se măsoară la derulare (rAF), nu cu IntersectionObserver: un salt (sus ↔ jos) trece peste observator fără
    // callback și bara rămânea aprinsă sus (găsit 20 oct. pe kit). Regula (QA GPT, 20 oct.): bara apare DOAR după ce blocul
    // principal de preț + buton (`watch`) a ieșit din ecran în sus și dispare când revine; nu acoperă subsolul.
    verifica(o);

    // Butonul din bară = butonul existent de coș.
    $$('[data-sc-bar-cta]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var tinta = $(o.cta, o.scope);
        if (!tinta) return;
        if (o.layer && !o.layer.hidden) inchideSheet(o);
        tinta.click();
      });
    });
    // Cantitatea din bară duce la pasul Cantitate (brief §3.1).
    $$('[data-sc-bar-qtylink]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var t = $(o.qty, o.scope);
        if (!t) return;
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var f = t.querySelector('input:checked, input, button');
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
      });
    });
    $$('[data-sc-bar-details]', root).forEach(function (b) {
      b.addEventListener('click', function () { deschideSheet(o, b); });
    });
    if (o.layer) {
      o.layer.addEventListener('click', function (e) {
        if (e.target === o.layer || e.target.closest('[data-sc-sheet-close]')) inchideSheet(o);
      });
      o.layer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { inchideSheet(o); return; }
        if (e.key !== 'Tab') return;
        var f = $$('button:not([disabled]), a[href], input:not([disabled])', o.layer).filter(function (x) { return x.offsetParent; });
        if (!f.length) return;
        var prim = f[0], ultim = f[f.length - 1];
        if (e.shiftKey && document.activeElement === prim) { e.preventDefault(); ultim.focus(); }
        else if (!e.shiftKey && document.activeElement === ultim) { e.preventDefault(); prim.focus(); }
      });
    }
    return o;
  }

  // `watch` = true cât blocul principal se vede SAU e încă dedesubt (n-a fost depășit): atunci bara stă ascunsă.
  function verifica(o) {
    var h = window.innerHeight;
    o.stare.start = !o.start || o.start.getBoundingClientRect().top < h;
    o.stare.watch = o.watch ? o.watch.getBoundingClientRect().bottom > 0 : false;
    o.stare.stop = o.stop ? o.stop.getBoundingClientRect().top < h : false;
    o.aplica();
  }

  // Pagina din spate nu se derulează cât e deschis sheet-ul. `overflow: hidden` singur nu ține pe iOS Safari, deci body-ul
  // se fixează la poziția curentă și se întoarce exact acolo la închidere.
  var blocat = null;
  function blocheaza() {
    if (blocat) return;
    var b = document.body, y = window.scrollY;
    blocat = { y: y, pos: b.style.position, top: b.style.top, width: b.style.width };
    document.documentElement.style.overflow = 'hidden';
    b.style.position = 'fixed'; b.style.top = -y + 'px'; b.style.width = '100%';
  }
  function deblocheaza() {
    if (!blocat) return;
    var b = document.body, y = blocat.y;
    b.style.position = blocat.pos; b.style.top = blocat.top; b.style.width = blocat.width;
    document.documentElement.style.overflow = '';
    blocat = null;
    window.scrollTo(0, y);
  }

  function marcheazaDetalii(o, deschis) {
    $$('[data-sc-bar-details]', o.root).forEach(function (b) { b.setAttribute('aria-expanded', deschis ? 'true' : 'false'); });
    o.root.classList.toggle('is-sheet-open', deschis);
  }

  function deschideSheet(o, din) {
    if (!o.layer) return;
    o.inapoi = din || document.activeElement;
    blocheaza();
    o.layer.hidden = false;
    marcheazaDetalii(o, true);
    var c = $('[data-sc-sheet-close]', o.layer);
    if (c) c.focus({ preventScroll: true });
  }

  function inchideSheet(o) {
    if (!o.layer || o.layer.hidden) return;
    o.layer.hidden = true;
    marcheazaDetalii(o, false);
    deblocheaza();
    if (o.inapoi && o.inapoi.focus) o.inapoi.focus({ preventScroll: true });
  }

  // `el` = orice element din secțiune (sau bara însăși). `d` = { selection, meta, total, note, cta, disabled, busy, rows: [[eticheta, valoare], …] }
  function update(el, d) {
    var scope = el && el.closest ? el.closest('[data-sc-bar-scope]') : null;
    var root = el && el.matches && el.matches('[data-sc-bar]') ? el
      : (scope && scope.__scBar) || $('[data-sc-bar]', scope || el || document);
    if (!root) return;
    var o = initBara(root);
    d = d || {};
    $$('[data-sc-bar-selection]', root).forEach(function (x) { text(x, d.selection); });
    $$('[data-sc-bar-meta]', root).forEach(function (x) { text(x, d.meta); });
    $$('[data-sc-bar-total]', root).forEach(function (x) { text(x, d.total); });
    $$('[data-sc-bar-note]', root).forEach(function (x) { text(x, d.note); });
    $$('[data-sc-bar-cta]', root).forEach(function (b) {
      if (d.cta != null) b.textContent = d.cta;
      if (d.disabled != null) b.disabled = !!d.disabled;
      b.classList.toggle('is-busy', !!d.busy);
    });
    if (d.rows) {
      var box = $('[data-sc-sheet-rows]', root);
      if (box) {
        box.textContent = '';
        d.rows.forEach(function (r) {
          var row = document.createElement('div'); row.className = 'sc-summary__row';
          var a = document.createElement('span'); a.className = 'sc-summary__label'; a.textContent = r[0];
          var b = document.createElement('span'); b.className = 'sc-summary__value'; b.textContent = r[1];
          row.appendChild(a); row.appendChild(b); box.appendChild(row);
        });
      }
      $$('[data-sc-bar-details]', root).forEach(function (b) { b.hidden = !d.rows.length; });
    }
    o.aplica();
  }

  // Bara de jos a temei (toolbar-mobile) stă peste bara noastră: o ridicăm deasupra ei. Ea intră cu o animație de 0,5 s,
  // deci se măsoară din nou la `transitionend` și după 800 ms (aceeași capcană ca la banner, 16 oct.).
  function ridica() {
    var tb = $('toolbar-mobile, .toolbar-mobile'), h = 0;
    if (tb) {
      var cs = getComputedStyle(tb), r = tb.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.position === 'fixed') h = Math.max(0, Math.min(r.height, window.innerHeight - r.top));
    }
    bare.forEach(function (o) { o.root.style.setProperty('--sc-bar-bottom', Math.round(h) + 'px'); verifica(o); });
  }
  var asteapta = false;
  function maiTarziu() { if (!asteapta) { asteapta = true; requestAnimationFrame(function () { asteapta = false; ridica(); }); } }

  /* ---------- 3. Galeria ---------- */

  function initGalerie(root) {
    if (root.__scGalerie) return;
    root.__scGalerie = true;
    var pista = $('[data-sc-gallery-track]', root);
    var mini = $$('[data-sc-gallery-thumb]', root);
    if (!pista) return;
    function marcheaza(i) {
      mini.forEach(function (m, k) {
        m.classList.toggle('is-selected', k === i);
        m.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    mini.forEach(function (m, i) {
      m.addEventListener('click', function () { arata(root, i); });
    });
    var rafG = false;
    pista.addEventListener('scroll', function () {
      if (rafG) return; rafG = true;
      requestAnimationFrame(function () { rafG = false; marcheaza(Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth))); });
    }, { passive: true });
    marcheaza(0);
  }

  function arata(root, i) {
    var pista = $('[data-sc-gallery-track]', root);
    if (pista) pista.scrollTo({ left: i * pista.clientWidth, behavior: 'smooth' });
  }

  /* ---------- Pornirea ---------- */

  function porneste(ctx) {
    // Editorul de temă reface secțiunea: bara veche (mutată în <body>) rămâne fără secțiune și se scoate.
    bare = bare.filter(function (o) { if (o.scope !== document && !o.scope.isConnected) { o.root.remove(); return false; } return true; });
    $$('[data-sc-bar]', ctx).forEach(initBara);
    $$('[data-sc-gallery]', ctx).forEach(initGalerie);
    ridica();
  }

  SC.bara = { init: initBara, update: update, deschide: function (el) { var o = initBara(el); deschideSheet(o); }, inchide: function (el) { inchideSheet(initBara(el)); } };
  SC.galerie = { init: initGalerie, arata: arata };
  SC.porneste = porneste;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { porneste(document); });
  else porneste(document);
  window.addEventListener('scroll', maiTarziu, { passive: true });
  window.addEventListener('resize', maiTarziu);
  setTimeout(ridica, 800);
  document.addEventListener('transitionend', function (e) { if (e.target && e.target.matches && e.target.matches('toolbar-mobile, .toolbar-mobile')) ridica(); });
  // Editorul de temă reîncarcă secțiunile fără să reîncarce pagina.
  document.addEventListener('shopify:section:load', function (e) { porneste(e.target); });
})();
